import { render } from "./PaslodeVue.vue?vue&type=template&id=42125c8c"
import script from "./PaslodeVue.vue?vue&type=script&lang=js"
export * from "./PaslodeVue.vue?vue&type=script&lang=js"

import "./PaslodeVue.vue?vue&type=style&index=0&id=42125c8c&lang=css"

import exportComponent from "/Users/adamklemm/vues/pmp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__